(function () {
    'use strict';

    $(document).ready(function () {
        if (!window.locationData || !window.$zopim) return;

        $zopim(function () {
            $zopim.livechat.setOnConnected(function () {
                var department = $zopim.livechat.departments.getDepartment(locationData.name);
                var defaultDepartment = 'UK Customer Services';

                if (department && department.status === 'online') {
                    $zopim.livechat.departments.filter(department.id);
                    $zopim.livechat.departments.setVisitorDepartment(department.id);
                } else {
                    $zopim.livechat.departments.filter(defaultDepartment);
                    $zopim.livechat.departments.setVisitorDepartment(defaultDepartment);
                }
            });
        });
    });
})();
